export default "{\n    \"overdue\": \"Vencido\",\n    \"expiresIn\": \"Vence en\"\n}\n"